var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinicSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20.873,
    viewBox: "0 0 21 20.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_build_24px",
    d: "M21.681,18.161,13.007,9.487a6.117,6.117,0,0,0-1.43-6.577A6.3,6.3,0,0,0,4.524,1.672l4.1,4.1L5.764,8.63,1.57,4.531a6.143,6.143,0,0,0,1.239,7.053,6.117,6.117,0,0,0,6.577,1.43l8.673,8.673a.921.921,0,0,0,1.334,0L21.585,19.5a.859.859,0,0,0,.1-1.334Z",
    transform: "translate(-0.956 -1.1)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicSettings);
export default __webpack_public_path__ + "static/media/clinic-settings.c94703cc24c5a21858d3eb9d7987f90b.svg";
export { ForwardRef as ReactComponent };